import { Grid, LinearProgress, Typography } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import styles from "./ProfileDetails.module.css";
import AppButton from "component/button/AppButton";
import profile_picture from "assets/images/profile-pic.svg";
import ornament from "assets/images/profile-ornament.svg";
import ModalLayout from "component/modalLayout/ModalLayout";
import EditProfile from "../EditProfile/EditProfile";
import { getResponsiveModalWidth } from "utils/helpers";
import { format, formatDistanceToNow } from "date-fns";
import { UserContext } from "context/UserContext";

const ProfileDetail = () => {
  const [openEditProfile, setOpenEditProfile] = useState(false);
  const [width, setWidth] = useState(getResponsiveModalWidth());

  useEffect(() => {
    getResponsiveModalWidth();
    window.addEventListener("resize", () => {
      setWidth(getResponsiveModalWidth());
    });
  }, []);

  const { user, loadingUser } = useContext(UserContext);

  return (
    <>
      {loadingUser ? (
        <LinearProgress />
      ) : (
        <>
          <div className={styles.heading}>
            <div className={styles.ornament1}>
              <img src={ornament} alt="" />
            </div>
            <div className={styles.ornament2}>
              <img src={ornament} alt="" />
            </div>
            <div className={styles.ornament3}>
              <img src={ornament} alt="" />
            </div>
            <div className={styles.profile_pic}>
              <img
                src={user?.avatar?.length > 0 ? user?.avatar : profile_picture}
                alt=""
              />
            </div>
            <div className={styles.btn}>
              <AppButton
                handleAction={() => {
                  setOpenEditProfile(true);
                }}
                width="180px"
                textColor="#FFFFFF"
                btnBg="#0072CE"
                btnText="Edit Profile"
              />
            </div>
          </div>
          <div className={styles.profile_details}>
            <div className={styles.profile_name}>
              <Typography>
                {user?.firstName || ""} {user?.lastName || ""}
              </Typography>
            </div>
            <Grid container item spacing={1}>
              <Grid item xs={12} sm={6} lg={3} xl={3}>
                <div className={styles.info}>
                  <p className={styles?.title}>Email</p>
                  <p className={styles?.value}>{user?.email || ""}</p>
                </div>
              </Grid>
              <Grid item  xs={12} sm={6} lg={3} xl={3}>
                <div className={styles.info}>
                  <p className={styles?.title}>Phone Number</p>
                  <p className={styles?.value}>{user?.phone || ""}</p>
                </div>
              </Grid>
            
              {/* <Grid item  xs={12} sm={6} lg={3} xl={3}>
                <div className={styles.info}>
                  <p className={styles?.title}>Employment Type</p>
                  <p
                    className={styles?.value}
                    style={{ textTransform: "capitalize" }}
                  >
                    {user?.employmentType || 'NA'}
                  </p>
                </div>
              </Grid> */}
              <Grid item  xs={12} sm={6} lg={3} xl={3}>
                <div className={styles.info}>
                  <p className={styles?.title}>Date Joined</p>
                  <p className={styles?.value}>
                    {format(new Date(user?.createdAt || null), "do MMMM, YYY")}
                  </p>
                </div>
              </Grid>
              <Grid item  xs={12} sm={6} lg={3} xl={2}>
                <div className={styles.info}>
                  <p className={styles?.title}>Last Active </p>
                  <p className={styles?.value}>
                    {formatDistanceToNow(new Date(user?.lastActive || null), {
                      addSuffix: true,
                    })}
                  </p>
                </div>
              </Grid>
            </Grid>
          </div>

          {openEditProfile && (
            <ModalLayout
              title="Edit Profile"
              handleClose={() => {
                setOpenEditProfile(false);
              }}
              width={width}
              openModal={openEditProfile}
              children={
                <EditProfile
                  profileDetails={user}
                  handleClose={() => setOpenEditProfile(false)}
                />
              }
            />
          )}
        </>
      )}
    </>
  );
};

export default ProfileDetail;